import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { GetEnumValuesDto, TypePayments } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import { PaginatedListOfGetResellerPaymentWithPaginationDto } from '../../../../../core/api/models/paginated-list-of-get-reseller-payment-with-pagination-dto';
import { TranslationService } from './../../../../../i18n/translation.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';

@Component({
    selector: 'app-base-payment-details',
    templateUrl: './base-payment-details.component.html',
    styleUrls: ['./base-payment-details.component.scss'],
    imports: [BaseIndexModule]
})
export class BasePaymentDetailsComponent
  extends BasePageComponent
  implements OnInit
{
  //#region Properties

  fields = 'pages.payments.fields.';
  pageName = 'payments';

  @Input('pageId') pageId: string;
  @Input('showReseller') showReseller: boolean = true;

  modelWithPagination$: Observable<
    any | PaginatedListOfGetResellerPaymentWithPaginationDto
  >;

  items$: Observable<Array<any>>;

  @Input('getTableDataApiMethodName') getTableDataApiMethodName: string;
  @Input('model') model;
  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  chequeImage: string = null;

  @Input() TypeBanksEnumValues: GetEnumValuesDto[] = [];
  @Input() TypePaymentStatusEnumValues: GetEnumValuesDto[] = [];
  @Input() TypePaymentsEnumValues: GetEnumValuesDto[] = [];

  get TypePayments() {
    return TypePayments;
  }

  //#endregion

  constructor(
    public translationService: TranslationService,
    private _sanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getUserState();
      this.getChequeImage();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  getChequeImage() {
    try {
      if (this.model.chequeImageAddress) {
        this.chequeImage = this._sanitizer.sanitize(
          SecurityContext.RESOURCE_URL,
          this._sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/png;base64,' + this.model.chequeImageAddress
          )
        );
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
